import React from 'react';
import { m } from 'framer-motion';
import { ShieldCheckIcon } from 'lucide-react';
export function Guarantee() {
  return <section className="bg-white py-10 sm:py-14" data-id="element-81" data-mp="20meizq13l45g">
      <div className="mx-auto max-w-3xl px-4 text-center sm:px-6" data-id="element-82" data-mp="24n8308bf5yt2">
        <m.div initial={{
        opacity: 0,
        y: 16
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.5
      }} className="rounded-3xl border border-success/25 bg-paper p-8 sm:p-10" data-id="element-83" data-mp="24lx34jl3hb78">
          <div className="mx-auto flex h-16 w-16 items-center justify-center rounded-full bg-success/10" data-id="element-84" data-mp="2jb1ilt0i91bn">
            <ShieldCheckIcon size={32} className="text-success" data-id="element-85" data-mp="2ociknruq6ttt" />
          </div>
          <h2 className="mt-5 font-heading text-2xl font-bold leading-tight text-primary sm:text-3xl" data-id="element-86" data-mp="2sd2eomk05hbq">
            Garantía 7 días
          </h2>
          <p className="mx-auto mt-4 max-w-xl text-sm leading-relaxed text-ink sm:text-base" data-id="element-87" data-mp="tz99zwqg129z">
            Si tienes problemas para acceder al material, falta alguno de los contenidos anunciados o lo
            recibido no corresponde con la oferta mostrada en esta página, escríbenos a{' '}
            <a href="mailto:manualeslistos@gmail.com" className="font-medium text-accent underline" data-id="element-88" data-mp="3nteybx93bq9y">
              manualeslistos@gmail.com
            </a>{' '}
            y lo resolveremos.
          </p>
        </m.div>
      </div>
    </section>;
}